import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";

const ApplyAdmission = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Apply Admission</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/applyadmission">Apply Admission</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-apply-admission-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-8 offset-xl-2 col-12">
              <div className="apply-admission-form">
                <form action="#" method="post">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <label>Student full name</label>
                        <input type="text" name="name" required />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input type="text" name="number" required />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <label>Where do you currently study?</label>
                        <input type="text" name="current-study" required />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <label>Class name</label>
                        <input type="text" name="class-name" required />
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-12">
                      <div class="form-group">
                        <label>Interested class</label>
                        <select
                          class="form-select "
                          aria-label=".form-select-lg example"
                        >
                          <option selected>Select class</option>
                          <option value="1">Class One</option>
                          <option value="2">Class Two</option>
                          <option value="3">Class Three</option>
                          <option value="4">Class Four</option>
                          <option value="5">Class Five</option>
                          <option value="6">Class Six</option>
                          <option value="7">Class Seven</option>
                          <option value="8">Class Eight</option>
                          <option value="9">Class Nine</option>
                          <option value="10">Class Ten</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-12">
                      <div class="form-group">
                        <label>Select group</label>
                        <select
                          class="form-select "
                          aria-label=".form-select-lg example"
                        >
                          <option selected>Select group</option>
                          <option value="1">Humanities</option>
                          <option value="2">Business Studies</option>
                          <option value="3">Science</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <label>Gurdian Name</label>
                        <input type="text" name="gurdian-name" required />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <label>Gurdian Relation</label>
                        <input type="text" name="gurdian-relation" required />
                      </div>
                    </div>
                    <div className="col-lg-6 offset-lg-6 col-md-6 offset-md-6 col-12">
                      <div className="apply-admission-button">
                        <button
                          type="submit"
                          className="eschool-btn secondary-btn"
                        >
                          Apply
                          <i className="fi fi-rs-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ApplyAdmission;
